import { createAction, props } from '@ngrx/store';
import { PwaPushNotificationsUserSettings } from '../../../services/pwa-push-notification/pwa-push-notifications-user-settings.type';

/**
 * Dispatched by the facade's `init()` to read the persisted subscription choice from
 * `PwaPushNotificationsLocalStorageService` into the slice.
 */
export const loadPwaPushNotificationSettings = createAction('[PwaPushNotification] Init');

/**
 * Dispatched by the init effect once the persisted settings have been read (or `undefined`,
 * for a first-time user who has never been asked).
 */
export const loadPwaPushNotificationSettingsSuccess = createAction(
    '[PwaPushNotification] Settings loaded',
    props<{ settings: PwaPushNotificationsUserSettings | undefined }>(),
);

/** Dispatched by the init effect when the storage read fails. */
export const loadPwaPushNotificationSettingsError = createAction('[PwaPushNotification] Settings load failed');

/**
 * Dispatched by the facade whenever the user's subscription choice changes (offered, subscribed).
 * Updates the slice immediately; the persist effect mirrors it to storage — the store is the
 * source of truth, storage is written on save and read only to rehydrate on the next `init()`.
 */
export const savePwaPushNotificationSettings = createAction(
    '[PwaPushNotification] Save settings',
    props<{ settings: PwaPushNotificationsUserSettings }>(),
);

export const subscribeToPushNotifications = createAction('[PwaPushNotification] Subscribe');

export const subscribeToPushNotificationsSuccess = createAction('[PwaPushNotification] Subscribe success');

export const subscribeToPushNotificationsFailure = createAction('[PwaPushNotification] Subscribe failure');

export const offerPushNotificationSubscription = createAction('[PwaPushNotification] Offer subscription');
